export default __webpack_public_path__ + "static/media/thumbs-down.d72046f4.png";